import { render, staticRenderFns } from "./AuctionApplyFee.vue?vue&type=template&id=c72b6556&scoped=true"
import script from "./AuctionApplyFee.vue?vue&type=script&lang=js"
export * from "./AuctionApplyFee.vue?vue&type=script&lang=js"
import style0 from "./AuctionApplyFee.vue?vue&type=style&index=0&id=c72b6556&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c72b6556",
  null
  
)

export default component.exports